<template>
  <v-dialog width="500px" v-model="show" @click:outside="$store.commit('close_trash_submission_dialog')">
    <v-card>
      <v-card-title>
        <div v-if="!restore">
          انتقال آثار به سطل زباله
        </div>
        <div v-else>
          حذف آثار از سطل زباله
        </div>
      </v-card-title>
      <v-card-text>
        <div v-if="restore">
          <div v-if="submissions.length===1">
            آیا می خواهید اثر زیر را بازیابی کنید؟
          </div>
          <div v-else>
            آیا می خواهید {{ submissions.length }} اثر را بازیابی کنید؟
          </div>
        </div>
        <div v-else>
          <div v-if="submissions.length===1">
            آیا از انتقال این اثر به سطل زباله اطمینان دارید؟
          </div>
          <div v-else>
            آیا می خواهید {{ submissions.length }} اثر را به سطل زباله اضافه کنید؟
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click="$store.commit('close_trash_submission_dialog')">
          لغو
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text
               @click="api_call" :loading="loading">
          تایید
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import {mapState} from "vuex";

export default {
  name: "TrashSubmissionDialog",
    props: {
    fetch_list: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    api_call() {
      this.$store.dispatch('trash_restore_submissions', ).then(() => {
        if (this.fetch_list) {
          this.$store.dispatch('filter_submission' , {trashed : true})
        }
        this.$store.commit('close_trash_submission_dialog');
        this.$store.commit('show_snackbar', {
          text: 'انتقال اثار به سطل زباله با موفقیت انجام شد.',
          type: 1
        });
      });
    },
  },
  computed: {
    ...mapState({
      show: state => state.Admin.settings.trash_submission_dialog.show,
      submissions: state => state.Admin.settings.trash_submission_dialog.submissions,
      loading: state => state.Admin.settings.trash_submission_dialog.loading,
      restore: state => state.Admin.settings.trash_submission_dialog.restore,
    }),
  }
}
</script>

<style scoped>

</style>
